'use client';

import { Box } from '@skin-seoul/design-system';
import SliderSection from './components/SliderSection';
import CenterButton from './components/CenterButton';
import BlurOverlays from './components/BlurOverlays';
import HoverArea from './components/HoverArea';
import { useSliderState } from './hooks/useSliderState';
import CenterBlurOverlay from './components/CenterBlurOverlay';
import { AnimatePresence } from 'motion/react';
interface SliderContent {
  leftSection: React.ReactNode;
  rightSection: React.ReactNode;
}
interface SliderProps {
  content: SliderContent;
}
export const BeforeAfterSlider = ({
  content
}: SliderProps) => {
  const {
    state,
    handlers
  } = useSliderState();
  const {
    hoveredSection,
    expandedSection,
    previousExpandedSection,
    hasExpanded
  } = state;
  const {
    onHover,
    onSectionClick,
    onCenterButtonClick
  } = handlers;
  const {
    leftSection,
    rightSection
  } = content;
  return <Box display="flex" justifyContent="center" alignItems="center" position="relative" data-sentry-element="Box" data-sentry-component="BeforeAfterSlider" data-sentry-source-file="BeforeAfterSlider.tsx">
      <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-source-file="BeforeAfterSlider.tsx">
        <CenterButton hoveredSection={hoveredSection} expandedSection={expandedSection} hasExpanded={hasExpanded} onClick={onCenterButtonClick} data-sentry-element="CenterButton" data-sentry-source-file="BeforeAfterSlider.tsx" />
        <CenterBlurOverlay expandedSection={expandedSection} data-sentry-element="CenterBlurOverlay" data-sentry-source-file="BeforeAfterSlider.tsx" />
        <Box width="100%" height="fit-content" userSelect="none" data-sentry-element="Box" data-sentry-source-file="BeforeAfterSlider.tsx">
          <SliderSection side="right" expandedSection={expandedSection} previousExpandedSection={previousExpandedSection} data-sentry-element="SliderSection" data-sentry-source-file="BeforeAfterSlider.tsx">
            {rightSection}
          </SliderSection>

          <SliderSection side="left" expandedSection={expandedSection} data-sentry-element="SliderSection" data-sentry-source-file="BeforeAfterSlider.tsx">
            {leftSection}
          </SliderSection>

          {!expandedSection && <>
              <BlurOverlays hoveredSection={hoveredSection} expandedSection={expandedSection} />
              <HoverArea side="left" onMouseEnter={() => onHover('left')} onMouseLeave={() => onHover(null)} onClick={() => onSectionClick('left')} expandedSection={expandedSection} hasExpanded={hasExpanded} />
              <HoverArea side="right" onMouseEnter={() => onHover('right')} onMouseLeave={() => onHover(null)} onClick={() => onSectionClick('right')} expandedSection={expandedSection} hasExpanded={hasExpanded} />
            </>}
        </Box>
      </AnimatePresence>
    </Box>;
};